/* eslint-disable @typescript-eslint/no-unused-vars */
import { StaticRegions } from 'store/deployment/static.regions'
import { MappingPoint } from '../store/floor-plan'
import { Point } from './draw'

/**
 * Disabling open-cv implementation since homography isn't needed right now. When the need comes, we can use a
 * different library or implement the math ourselves.
 *
 * Keeping the code below for reference.
 */

export interface Mat {}

/**
 * You can read more about findHomography here: https://scottsuhy.com/2021/02/01/image-alignment-feature-based-in-opencv-js-javascript/
 * findHomography returns a matrix that we can use to predict a destination point using perspectiveTransform
 */
export function homographyMatrix(_src: MappingPoint[] = [], _dst: MappingPoint[] = []): Mat {
    // const srcPoints = src?.map((m) => m.point).flat() || []
    // const dstPoints = dst?.map((m) => m.point).flat() || []
    // const srcMat = matFromArray(src.length, 1, CV_32FC2, srcPoints)
    // const dstMat = matFromArray(dst.length, 1, CV_32FC2, dstPoints)

    // const homography = findHomography(srcMat, dstMat, RANSAC)

    // if (homography.empty()) {
    //     throw new Error('homography matrix is empty')
    // }

    // return homography

    return {}
}

/**
 * If we have a homography generated from two sets of points, we can predict the location of a destination point using perspectiveTransform
 *
 * Example: We provide 4 sets of points for both a floor plan (src) and a snapshot (dst). It's important that the points are adjusted and
 * placed correctly, otherwise homography may return an empty matrix. homographyMatrix(floorPlanPoint[], streamPoint[]) will return a matrix
 * we can use to predict a destination point. Note that we provided floor plan points as the src when generating the matrix.  When calling
 * perspectiveTransformWithPoint(), you will need to pass in a source point into the function to predict the destination point. In our example,
 * we'll need to pass in a new floor plan point into the perspectiveTransform function to calculate the new destination point (stream point).
 * perspectiveTransformPoint(homographyMatrix(floorPlanPoint[], streamPoint[]), floorPlanPoint) => streamPoint
 */
export function perspectiveTransformWithPoint(_homography: Mat, _point: Point): Point {
    // const pointMat = matFromArray(1, 1, CV_32FC2, point)
    // const outputMat = new Mat(1, 1, CV_32FC2)
    // perspectiveTransform(pointMat, outputMat, homography)

    // return [outputMat.data32F[0], outputMat.data32F[1]]

    return [0, 0]
}

export function matToArray(_mat: Mat): number[][] {
    // try {
    //     const homography = this.matrix
    //     return [
    //         [homography.data64F[0], homography.data64F[1], homography.data64F[2]],
    //         [homography.data64F[3], homography.data64F[4], homography.data64F[5]],
    //         [homography.data64F[6], homography.data64F[7], homography.data64F[8]],
    //     ]
    // } catch (e) {
    //     return []
    // }

    return []
}

export function transformRegionsWithMatrix(staticRegions: StaticRegions[], matrix?: Mat): StaticRegions[] {
    if (!matrix) {
        return []
    }

    return staticRegions.reduce((list, { id, name, regions, itemType }) => {
        const transformedRegions = [...regions].map((region) => ({
            ...region,
            polygons: region.polygons.map((regionPolygons) => ({
                ...regionPolygons,
                polygon: regionPolygons.polygon.map((p) => perspectiveTransformWithPoint(matrix, p)),
            })),
        }))
        list.push(new StaticRegions(id, name, transformedRegions, itemType))
        return list
    }, [] as StaticRegions[])
}
